import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  key: 0,
  class: "mc",
  style: {"margin-top":"10px"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = {
  class: "centered w100",
  style: {"padding-top":"10px"}
}
const _hoisted_5 = {
  class: "mc",
  style: {"width":"800px"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", {
  class: "header_title fs24 mt20",
  style: {}
}, "限定公開設定", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "mt40" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", {
  class: "header_title fs18 fl mr20",
  style: {}
}, "確定権限", -1)
const _hoisted_12 = {
  key: 0,
  class: "fl ml20",
  style: {"width":"430px"}
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "fl fs13 kakugo" }, "日程調整を確定できるユーザーを選択してください。", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SettingsTabContent = _resolveComponent("SettingsTabContent")!
  const _component_FixTypeButtons = _resolveComponent("FixTypeButtons")!
  const _component_RoomSettingsUseChatContent = _resolveComponent("RoomSettingsUseChatContent")!
  const _component_RoomDetailSettings = _resolveComponent("RoomDetailSettings")!
  const _component_RoomSettingsAvailableTime = _resolveComponent("RoomSettingsAvailableTime")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.rcm && _ctx.rcm.room)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("section", {
                class: _normalizeClass(`mt20 rad20 kakugo calendarfirst with_white_bg ofs ${_ctx.isSP ? 'pad20' : 'pad40'}`)
              }, [
                _hoisted_6,
                _hoisted_7,
                _hoisted_8,
                _createVNode(_component_SettingsTabContent, {
                  selectedTabName: _ctx.selectedTabName,
                  selectTab: _ctx.selectTab
                }, null, 8, ["selectedTabName", "selectTab"]),
                (_ctx.selectedTabName == `public`)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _hoisted_11,
                        (_ctx.rcm.appo)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                              _hoisted_13,
                              _hoisted_14,
                              _createVNode(_component_FixTypeButtons, {
                                appo: _ctx.rcm.appo,
                                onFixBy: _ctx.fixBy
                              }, null, 8, ["appo", "onFixBy"])
                            ]))
                          : _createCommentVNode("", true),
                        _hoisted_15
                      ]),
                      _hoisted_16,
                      _hoisted_17,
                      (_ctx.showChatContent)
                        ? (_openBlock(), _createBlock(_component_RoomSettingsUseChatContent, {
                            key: 0,
                            class: "fl mt20 text-left"
                          }))
                        : _createCommentVNode("", true),
                      _hoisted_18,
                      _hoisted_19,
                      _hoisted_20,
                      _createVNode(_component_RoomDetailSettings, {
                        from: `parent_room`,
                        editProviderEvent: _ctx.editProviderEvent
                      }, null, 8, ["editProviderEvent"])
                    ]))
                  : (_openBlock(), _createBlock(_component_RoomSettingsAvailableTime, { key: 1 }))
              ], 2)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}